import { authQueryKeys as e } from "../queries/state/useAuthQueryKeys.mjs";
import { useEffect as t } from "react";
import { useQueryClient as n } from "@maat/store-hooks";
import { setUnauthorizedHandler as r } from "@maat/api-base";
//#region src/hooks/useSessionEndedSync.ts
var i = () => {
	let i = n();
	t(() => (r(() => {
		i.invalidateQueries({ queryKey: e.state() }), i.invalidateQueries({ queryKey: e.me() });
	}), () => r(void 0)), [i]);
};
//#endregion
export { i as useSessionEndedSync };
